import {
    IIconStyles,
    ILabelStyles,
    mergeStyles,
    IStyle,
    IModalProps,
    IDragOptions,
    ContextualMenu,
    IDialogContentProps,
    DialogType, IDialogStyleProps, IDialogStyles, IStyleFunctionOrObject
  } from 'office-ui-fabric-react';
import { AppLayoutSettings } from '../../common/styles/common.styles';


export const getDiamondIconStyles = (): IIconStyles => {
    return {
        root: {
            color: AppLayoutSettings.getAppColorContainer().wordBlue.value,
            fontSize: "20px",
        }
    };
};

export const getDialogContentProps = (title: string | JSX.Element, showCloseButton: boolean = false): IDialogContentProps => {
  return {
    type: DialogType.normal,
    showCloseButton,
    title
  }
};


export const getModalProps = (): IModalProps => {
  const dragOptions: IDragOptions = {
      moveMenuItemText: TranscriptionStrings.MoveLabel,
      closeMenuItemText: TranscriptionStrings.CloseLabel,
      menu: ContextualMenu,
  };

  return {
      isBlocking: true,
      styles: {
          root: getModalDialogStyles()
      },
      dragOptions
    }
};

export const getTopLabelStyles = (): ILabelStyles => {
    const commonLabelStyles = AppLayoutSettings.AppCommonStyles.getPageTopLabelStyles();
    const specificStyle: ILabelStyles = {
      root: {
        fontWeight: "bold"
      }
    };

    return {
      root: mergeStyles(commonLabelStyles.root, specificStyle.root)
    };
};

export const getModalDialogStyles = (): IStyle => {
    return {
        position: "initial"
    };
}

export const getDialogStyles = (minHeight: string = '140px'): IStyleFunctionOrObject<IDialogStyleProps, IDialogStyles> => {
  return {
    main: {
      marginTop:  window.innerHeight/3,
      position: "relative",
      backgroundColor: AppLayoutSettings.getAppColorContainer().defaultBackgroundColor.value,
      minHeight: minHeight
    }
  }
}

export const getDialogStylesZoomedOut = (): IStyleFunctionOrObject<IDialogStyleProps, IDialogStyles> => {
  return {
    main: {
      marginTop: "30px",
      position: "relative",
      backgroundColor: AppLayoutSettings.getAppColorContainer().defaultBackgroundColor.value,
      minHeight: "140px"
    }
  }
}